import Vue from 'vue';
const CamaraEventBus = new Vue();
export default CamaraEventBus;
